import React from 'react';
import { Modal, Box, Typography, Button, CircularProgress, IconButton } from '@mui/material';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';

const ModalContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 420px;
  background: #fff;
  border-radius: 20px;
  padding: 32px 40px;
  text-align: center;
  font-family: 'Urbanist';
`;

const ApproveButton = styled(Button)`
  && {
    background-color: #12188a;
    color: white;
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    text-transform: none;
    font-family: 'Urbanist';
    margin-top: 24px;
    font-weight: 600;

    &:hover {
      background-color: #0f156e;
    }
  }
`;

const ApproveModal = ({
  open,
  handleClose,
  onApprove,
  isApproving = false,
  title = "Are You Sure You Want to Approve This Recommendation?",
  description = "This action will add the boss and the recommendation on the platform. The boss and employee will be notified.",
  approveButtonText = "Approve",
  children
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <ModalContainer>
        <IconButton
          onClick={handleClose}
          style={{ position: 'absolute', top: 16, right: 16 }}
        >
          <CloseIcon />
        </IconButton>

        {children ? (
          children
        ) : (
          <>
            <Typography
              variant="h5"
              sx={{
                fontSize: '20px',
                fontWeight: 600,
                mb: 2,
                textAlign: 'center'  // Add this line
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                color: '#666',
                lineHeight: '22px',
                textAlign: 'center'  // Add this line
              }}
            >
              {description}
            </Typography>
          </>
        )}

        <ApproveButton
          onClick={onApprove}
          disabled={isApproving}
        >
          {isApproving ? (
            <>
              <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
              {`${approveButtonText}ing...`}
            </>
          ) : (
            approveButtonText
          )}
        </ApproveButton>
      </ModalContainer>
    </Modal>
  );
};

export default ApproveModal;